import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import { reduxForm, Form } from 'redux-form';
import { loadingErrorSelector, loadingIsLoadingSelector } from '../../Redux/loading/selectors';
import { SaveErrorPropType } from '../../proptypes/errors';
import { setLoading } from '../../Redux/loading/actions';
import { exportDataRequest } from './hooks';

import LoadingButton from '../Helpers/LoadingButton';

const EXPORT_TYPE = 'a1';
const FORM_KEY = 'a1_export';

const A1Export = ({ handleSubmit, saveError, isLoading, formValues }) => (
    <Box mt={3}>
        <Card id="export-a1" data-cy="card-a1">
            <h6 className="card-header">A1 Report</h6>
            <CardBody>
                <p>
                    Unter folgendem Link kann die Datei heruntergeladen werden
                </p>
                <Form onSubmit={handleSubmit}>
                    <div className="text-center">
                        <LoadingButton
                            color="primary"
                            id={FORM_KEY}
                            title="Klicken um die Datei herunterzuladen"
                            type="submit"
                            isLoading={isLoading}
                        >
                            Herunterladen
                        </LoadingButton>
                    </div>
                </Form>
            </CardBody>
        </Card>
    </Box>
);

A1Export.propTypes = {
    saveError: SaveErrorPropType,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    formValues: PropTypes.object.isRequired, 
};

export default connect(
    (state) => ({
        saveError: loadingErrorSelector(state, FORM_KEY),
        isLoading: loadingIsLoadingSelector(state, FORM_KEY),
        formValues: state.form[FORM_KEY]?.values || {}, 
    }),
    (dispatch) => ({
        onSubmit: async (values) => {
            dispatch(setLoading(true, FORM_KEY));
            try {
                await exportDataRequest(EXPORT_TYPE, values);
            } finally {
                dispatch(setLoading(false, FORM_KEY));
            }
        },
    })
)(reduxForm({ form: FORM_KEY })(A1Export));
